import state from './moduleTenantCustomerState.js'
import mutations from './moduleTenantCustomerMutations.js'
import actions from './moduleTenantCustomerActions.js'
import getters from './moduleTenantCustomerGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

